import { render, staticRenderFns } from "./CanPublishPlatform.vue?vue&type=template&id=044e3bfe&scoped=true"
import script from "./CanPublishPlatform.vue?vue&type=script&lang=js"
export * from "./CanPublishPlatform.vue?vue&type=script&lang=js"
import style0 from "./CanPublishPlatform.vue?vue&type=style&index=0&id=044e3bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044e3bfe",
  null
  
)

export default component.exports